import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IError } from "../../../interfaces/base";
import {
  IGetRecipePayload,
  IRecipeState,
  ICreateRecipePayload,
  IUpdateRecipePayload,
  IDeleteRecipePayload,
} from "../../../interfaces/store/recipe-interface";

const initialState: IRecipeState = {
  recipe: null,
  error: null,
  loading: false,
  requestState: "prepare",
  operation: null,
};

const _getRecipeStart = (
  state: IRecipeState,
  { payload }: PayloadAction<IGetRecipePayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "read";
};

const _getRecipeSuccess = (
  state: IRecipeState,
  { payload }: PayloadAction<any>
) => {
  state.recipe = payload;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _getRecipeFailed = (
  state: IRecipeState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.requestState = "error";
};

const _resetRecipe = (state: IRecipeState) => {
  state.recipe = null;
  state.error = null;
  state.loading = false;
  state.requestState = "prepare";
  state.operation = null;
};

const _createRecipeStart = (
  state: IRecipeState,
  { payload }: PayloadAction<ICreateRecipePayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "create";
};

const _createRecipeSuccess = (
  state: IRecipeState,
  { payload }: PayloadAction<any>
) => {
  state.recipe = payload;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _createRecipeFailed = (
  state: IRecipeState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.recipe = null;
  state.requestState = "error";
};

const _updateRecipeStart = (
  state: IRecipeState,
  { payload }: PayloadAction<IUpdateRecipePayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "update";
};

const _updateRecipeSuccess = (
  state: IRecipeState,
  { payload }: PayloadAction<any>
) => {
  state.recipe = payload;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _updateRecipeFailed = (
  state: IRecipeState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.recipe = null;
  state.requestState = "error";
};

const _deleteRecipeStart = (
  state: IRecipeState,
  { payload }: PayloadAction<IDeleteRecipePayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "delete";
};

const _deleteRecipeSuccess = (
  state: IRecipeState,
  { payload }: PayloadAction<any>
) => {
  state.recipe = null;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _deleteRecipeFailed = (
  state: IRecipeState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.recipe = null;
  state.requestState = "error";
};

const RecipeSlice = createSlice({
  name: "recipe",
  initialState,
  reducers: {
    getRecipeStart: _getRecipeStart,
    getRecipeSuccess: _getRecipeSuccess,
    getRecipeFailed: _getRecipeFailed,
    resetRecipe: _resetRecipe,
    createRecipeStart: _createRecipeStart,
    createRecipeSuccess: _createRecipeSuccess,
    createRecipeFailed: _createRecipeFailed,
    updateRecipeStart: _updateRecipeStart,
    updateRecipeSuccess: _updateRecipeSuccess,
    updateRecipeFailed: _updateRecipeFailed,
    deleteRecipeStart: _deleteRecipeStart,
    deleteRecipeSuccess: _deleteRecipeSuccess,
    deleteRecipeFailed: _deleteRecipeFailed,
  },
});

export const {
  getRecipeStart,
  getRecipeSuccess,
  getRecipeFailed,
  resetRecipe,
  createRecipeStart,
  createRecipeSuccess,
  createRecipeFailed,
  updateRecipeStart,
  updateRecipeSuccess,
  updateRecipeFailed,
  deleteRecipeStart,
  deleteRecipeSuccess,
  deleteRecipeFailed,
} = RecipeSlice.actions;
export default RecipeSlice.reducer;
